/* @flow */

import shared from "../../../shared/src/translations/sv_SE";

export default {
  ...shared,
};
